import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';

import { LoadingView } from '../../components';

import Config from '../../config';
import Session from '../../modules/Session';
import { HUBBLE_SESSION_AUTH, LOGIN_STATES } from '../../modules/Login';

const Login = () => {
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const { loginStatus, redirect, token } =
      Session.get(HUBBLE_SESSION_AUTH) || {};

    const doLogin = (s, t, r) => {
      // Send loggedin event for use in the permissions module
      if (s === LOGIN_STATES.loggedin) {
        window.dispatchEvent(
          new CustomEvent(LOGIN_STATES.loggedin, {
            detail: {
              token: t,
            },
          })
        );
      }

      Session.set(HUBBLE_SESSION_AUTH, {
        token: t,
        loginStatus: s,
        redirect: r,
      });
      history.push(r || '/');
    };

    const doFetch = async () => {
      const queryParams = queryString.parse(location.search);
      const res = await fetch(
        `${
          Config.pronvest.api.url
        }AzureAD/Exchange/Hubble?${queryString.stringify(queryParams)}`,
        {
          method: 'GET',
        }
      );
      const r = await res.json();
      const accessToken =
        r.access_Token || r.accessToken || r.access_token || '';

      doLogin(LOGIN_STATES.loggedin, accessToken, redirect);
    };

    if (loginStatus !== LOGIN_STATES.loggedin) {
      doFetch();
    } else {
      doLogin(loginStatus, token, redirect);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingView message="Logging you in..." />;
};

export default Login;
